const defaults = {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
        xs: 20,
        sm: 20,
        md: 42,
        lg: 72,
        xl: 72,
    },
    unit: 'rem',
};
const createMaxWidths = (mw = defaults) => ({
    ...mw,
    width: (breakpoint) => `${mw.values[breakpoint]}${mw.unit}`,
});
export { createMaxWidths };
